module.exports = __webpack_public_path__ + "static/media/redeem-code-icon.e64dea7e.svg";